// components/SettingsPage.jsx
import React from "react";

const SettingsPage = () => {
  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">⚙️ Settings</h2>
      <p>This is the settings page. You can add your configuration and user preferences here.</p>
    </div>
  );
};

export default SettingsPage;
